module.exports = __webpack_public_path__ + "media/images/games/35gender/basketballplayer-03c54d138916259951064c0935306e20.png";